<script setup lang="ts">
import { useHttpStore } from "@/stores/http/index.ts";
import { useRouter } from "vue-router";
import { setDeviceDidAuth } from "@/services/device.js";
import { onMounted } from "vue";
import AuthMessage from "@/cms/components/SiteSwitcher/AuthMessage.vue";

defineOptions({
  layout: "utility",
});

const httpStore = useHttpStore();
const router = useRouter();

onMounted(async () => {
  try {
    setDeviceDidAuth();

    const { appState } = await httpStore.auth0Client.handleRedirectCallback();
    const { target } = appState;

    if (target) {
      router.push(target);
    } else {
      router.push("/post-redirect/lookup");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    console.log(err);
    router.push("/");
  }
});
</script>

<template>
  <AuthMessage label="Secure session created! Signing in..." />
</template>
